<div class="form-input" appClickOutside (onClickOutSide)="show=false">
  <div class="input-group">
    @if(selected) {
      <div class="selector"
           [style.color]="selected.color.text"
           [style.background-color]="selected.color.background"
           [style.border-color]="selected.color.background"
           (click)="show=true">
        {{ selected.value.name }}
      </div>
    } @else {
      <div class="selector" (click)="show=true">
        {{ placeholder|translate }}
      </div>
    }

    <div class="sub-menu" [class.hide]="!show">
      <mat-expansion-panel class="mat-elevation-z0" *ngFor="let group of (options | groupSelectPrestationType)"
                           hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ group.name }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="item" *ngFor="let item of group.prestations"
             [style.color]="item.color.text"
             [style.background-color]="item.color.background"
             (click)="selectValue(item)">{{ item.label + ' (' + item.startHours + ' - ' + item.endHours + ')' }}</div>
      </mat-expansion-panel>
    </div>
  </div>
  <div class="validate" (click)="onClickAdd()">
    <i class="fa-regular fa-circle-check"></i>
  </div>
</div>
